import { gql } from "apollo-angular";

export const CREATE_SPECIFICATION_COVERAGE_MUTATION = gql`mutation configuratorCreateSpecificationCoverage($SpecificationCoverage: SpecificationCoverageInput) {
    configuratorCreateSpecificationCoverage(SpecificationCoverage: $SpecificationCoverage) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const UPDATE_SPECIFICATION_COVERAGE_MUTATION = gql`mutation configuratorUpdateSpecificationCoverage($SpecificationCoverage: SpecificationCoverageInput) {
    configuratorUpdateSpecificationCoverage(SpecificationCoverage: $SpecificationCoverage) {
        responseMessages
        returnValue
        success
    }
  }
  `
  

export const DELETE_SPECIFICATION_COVERAGE_MUTATION = gql`mutation configuratorDeleteSpecificationCoverage($Uid: String!) {
    configuratorDeleteSpecificationCoverage(Uid: $Uid)
  }
  `
  